import { render, staticRenderFns } from "./position.vue?vue&type=template&id=649a8bda&scoped=true"
import script from "./position.vue?vue&type=script&lang=js"
export * from "./position.vue?vue&type=script&lang=js"
import style0 from "./position.vue?vue&type=style&index=0&id=649a8bda&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649a8bda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('649a8bda')) {
      api.createRecord('649a8bda', component.options)
    } else {
      api.reload('649a8bda', component.options)
    }
    module.hot.accept("./position.vue?vue&type=template&id=649a8bda&scoped=true", function () {
      api.rerender('649a8bda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/basic/position/position.vue"
export default component.exports